import API from "../../..";
import { useQueryWrapper } from "../../wrappers";
import { roomUsedLicensesKey } from "../room-query-keys";

export function useQueryGetRoomUsedLicenses(enabled: boolean, userId?: string) {
  const {
    isLoading,
    isFetching,
    data: usedLicenses,
    isError,
  } = useQueryWrapper({
    queryKey: roomUsedLicensesKey(userId ?? ""),
    queryFn: () => API.Rooms.getRoomUsedLicenses(userId),
    enabled,
  });
  return {
    isLoading,
    isFetching,
    usedLicenses: usedLicenses ?? [],
    isError,
  };
}
